import { FC } from "react";

const Error500: FC = () => {
  return (
    <>
      <h1 className="font-bold text-4xl text-gray-700 mb-10">System Error</h1>

      <div className="font-semibold text-lg text-gray-400 mb-15">
        Something went wrong! <br /> Please try again later.
      </div>
      <div
        className="min-h-[100px] shrink-0 bg-contain bg-center bg-bottom bg-no-repeat lg:min-h-[350px]"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/media/illustrations/sketchy-1/17.png)`,
        }}
      />
    </>
  );
};

export { Error500 };
